import React from 'react';
import getEnvironmentVariables from '@/config/environment';
import { isServer } from '@/helpers/isServer';

const setupAxeCore = () => {
  const { ENABLE_ACCESSIBILITY_CHECKS } = getEnvironmentVariables();

  if (!isServer() && ENABLE_ACCESSIBILITY_CHECKS) {
    const ReactDOM = require('react-dom');
    const axe = require('@axe-core/react');
    axe(React, ReactDOM, 1000);
  }
};

export default setupAxeCore;
